// src/prototype/components/CompareTray.tsx
// Floating tray that appears once any use case is checked for comparison.
import React from 'react';
import { Columns, X } from 'lucide-react';
import { MAX_COMPARE, MIN_COMPARE } from '../hooks/useCompareSelection';

export interface CompareTrayProps {
  count: number;
  onCompare: () => void;
  onClear: () => void;
}

export const CompareTray: React.FC<CompareTrayProps> = ({ count, onCompare, onClear }) => {
  if (count === 0) return null;
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-20 bg-[#18365E] text-white rounded-full shadow-lg pl-5 pr-2 py-2 flex items-center gap-3">
      <span className="text-xs font-semibold">
        {count} selected {count >= MAX_COMPARE && <span className="opacity-60">(max {MAX_COMPARE})</span>}
      </span>
      <button
        onClick={onCompare}
        disabled={count < MIN_COMPARE}
        title={count < MIN_COMPARE ? `Select at least ${MIN_COMPARE} to compare` : undefined}
        className="bg-[#FF6E4C] disabled:opacity-40 disabled:cursor-not-allowed text-white text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-1.5 hover:bg-[#e85f3f] transition-colors"
      >
        <Columns className="w-3.5 h-3.5" />
        Compare
      </button>
      <button
        onClick={onClear}
        aria-label="Clear comparison selection"
        className="text-white/60 hover:text-white transition-colors pr-1.5"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default CompareTray;
